import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";
import { useStaticQuery, graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import KCReactPlayer from "Components/common/kcReactPlayer";
import ContentModal from "Components/common/base/contentModal";

const StyledWrapper = styled.div`
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) => props.theme.responsive.mobile} {
    flex-direction: ${(props) =>
      props.align === "left" ? "row" : "row-reverse"};
  }
`;

const StyledVideoWrapper = styled.div`
  flex: 1 1 50%;
  width: 100%;
  margin-bottom: 1rem;
  margin-left: 0rem;
  margin-right: 0rem;
  ${(props) => props.theme.responsive.mobile} {
    width: 50%;
    margin-right: 3rem;
  }
`;

const StyledContentWrapper = styled.div`
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  ${(props) => props.theme.responsive.mobile} {
    padding: 0;
    width: 50%;
  }
`;

const StyledCTA = styled.div`
  margin-top: 0rem;
  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
`;

const CustomFitModal = ({ title, description, vimeoURL, align = "left" }) => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    {
      appStore: file(relativePath: { eq: "Icon/appStore.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, quality: 100, layout: CONSTRAINED)
        }
      }
    }
  `);
  const handleInstallApp = () => {
    window.open(
      "https://apps.apple.com/us/app/king-children/id1351987953",
      "_blank"
    );
  };
  return (
    <StyledWrapper align={align}>
      <StyledVideoWrapper>
        <KCReactPlayer url="https://vimeo.com/434499914" />
      </StyledVideoWrapper>
      <StyledContentWrapper labelColor="black">
        <ContentModal title={title} content={description} />
        <StyledCTA onClick={() => handleInstallApp()}>
          <StaticImage
            style={{ width: "10rem" }}
            src="../../../images/Icon/appStore.png"
            alt="Install App"
          />
        </StyledCTA>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

export default CustomFitModal;

export const query = graphql`
  fragment customFitModal on STRAPI_ComponentBaseCustomFitModal {
    __typename
    id
    title {
      en
      es
      it
    }
    description {
      en
      es
      it
    }
  }
`;
